import { GetDegreeListConst } from "../constant/ApplicationConstant";
import { rememberQuery } from "../../helper/lastQuery";
import {
  GetAgentListConst,
  GetBranchByOrgIdConst,
  GetCatalogListConst,
  GetContractListConst,
  GetCountryListConst,
  GetFilteredUserConst,
  GetOrganizationListConst,
  GetProcessListConst,
  GetProgramListConst,
  GetRoleListConst,
  GetSettingCountConst,
  GetUniversityListConst,
  GetUserChatByIdConst,
  GetUserChatConst,
  GetUserListConst,
  SaveRolesConst,
  GetStateListConst,
  PromotedUniversityConst,
  GetCurrencyListConst,
} from "../constant/SettingConstant";

import {
  GetAgentListService,
  GetBranchByOrganizationIdService,
  GetCatalogListService,
  GetContractListService,
  GetCountryListService,
  GetCurrencyListService,
  GetDegreeListService,
  GetFilteredUserService,
  GetOrganizationListService,
  GetProcessListService,
  GetProgramListService,
  GetRoleListService,
  GetSettingCountService,
  GetStateListService,
  GetUniversityListService,
  GetUserChatByIdService,
  GetUserChatService,
  GetUserListService,
  MarkedChatPinned,
  MarkedChatUnread,
  PromotedUniversityService,
} from "../service/SettingService";

export const GetUniversityAction = (pagination={limit:0,page:1}) => async (dispatch) => {
  try {
    rememberQuery("university", pagination);
    const data = await GetUniversityListService(pagination);

    dispatch({ type: GetUniversityListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetUniversityListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetAgentAction = (page={limit:0,page:1}) => async (dispatch) => {
  try {
    rememberQuery("agent", page);
    const data = await GetAgentListService(page);

    dispatch({ type: GetAgentListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetAgentListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetOrganizationAction = (page= { limit: 0, page: 1 }) => async (dispatch) => {
  try {
    rememberQuery("organization", page);
    const data = await GetOrganizationListService(page);

    dispatch({ type: GetOrganizationListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetOrganizationListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetRoleAction = () => async (dispatch) => {
  try {
    const data = await GetRoleListService();

    dispatch({ type: GetRoleListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetRoleListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetUserAction = (page= { limit: 0, page: 1 }) => async (dispatch) => {
  try {
    rememberQuery("user", page);
    const data = await GetUserListService(page);

    dispatch({ type: GetUserListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetUserListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};
export const GetCatalogAction = (page= { limit: 0, page: 1 }) => async (dispatch) => {
  try {
    const data = await GetCatalogListService(page);

    dispatch({ type: GetCatalogListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetCatalogListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetProgramAction = (id,page= { limit: 0, page: 1 }) => async (dispatch) => {
  try {
    rememberQuery("program", { id, page });
    const data = await GetProgramListService(id,page);

    dispatch({ type: GetProgramListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetProgramListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetCountryAction = (page={limit:0,page:1}) => async (dispatch) => {
  try {
    const data = await GetCountryListService(page);

    dispatch({ type: GetCountryListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetCountryListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetCurrencyAction = () => async (dispatch) => {
  try {
    const data = await GetCurrencyListService();

    dispatch({ type: GetCurrencyListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetCurrencyListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetDegreeAction = () => async (dispatch) => {
  try {
    const data = await GetDegreeListService();

    dispatch({ type: GetDegreeListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetDegreeListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetContractTypeAction = (page={limit:0,page:1},newToggleState=false) => async (dispatch) => {
  try {
    const data = await GetContractListService(page,newToggleState);

    dispatch({ type: GetContractListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetContractListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};
export const GetStateListAction = (country) => async (dispatch) => {
  try {
    const data = await GetStateListService(country);

    dispatch({ type: GetStateListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetStateListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetProcessAction = (id,page={limit:0,page:1}) => async (dispatch) => {
  try {
    const data = await GetProcessListService(id,page);

    dispatch({ type: GetProcessListConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetProcessListConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};
export const GetUserChatAction = () => async (dispatch) => {
  try {
    const data = await GetUserChatService();

    dispatch({ type: GetUserChatConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetUserChatConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};


export const MarkedChatAsPinned = (id, action = "pin") => async (dispatch) => {
  try {
    const data = await MarkedChatPinned(id, action);
    return data;
  } catch (error) {
    throw error;
  }
};

export const MarkedChatAsUnread = (id) => async (dispatch) => {
  try {
    const data = await MarkedChatUnread(id);
    return data;
  } catch (error) {
    throw error;
  }
};


export const GetSettingCountAction = () => async (dispatch) => {
  try {
    const data = await GetSettingCountService();

    dispatch({ type: GetSettingCountConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetSettingCountConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};
export const GetFilteredUserAction = (value) => async (dispatch) => {
  try {
    const data = await GetFilteredUserService(value);

    dispatch({ type: GetFilteredUserConst, payload: data });

    // alert("Login Sucessfully!")
  } catch (error) {
    dispatch({ type: GetFilteredUserConst, payload: error });
    //.log(error);
    // alert("Error :", error);
  }
};

export const GetUserChatByIdAction = (id) => async (dispatch) => {
  try {
    const data = await GetUserChatByIdService(id);
    dispatch({ type: GetUserChatByIdConst, payload: data });
  } catch (error) {
    dispatch({ type: GetUserChatByIdConst, payload: error });
  }
};


export const GetPromotedUniversityAction = () => async (dispatch) => {
  try {
    const data = await PromotedUniversityService();

    dispatch({ type: PromotedUniversityConst, payload: data });
  } catch (error) {
    dispatch({ type: PromotedUniversityConst, payload: error });
  }
};



export const GetBranchByOrgIdAction = (id) => async (dispatch) => {
  try {
    const data = await GetBranchByOrganizationIdService(id);

    dispatch({ type: GetBranchByOrgIdConst, payload: data });
  } catch (error) {
    dispatch({ type: GetBranchByOrgIdConst, payload: error });
  }
};

export const saveRoles = (data) => async (dispatch) => {
  //(data)
  dispatch({ type: SaveRolesConst, payload: data });
};
